import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { constants } from '../../helpers'
import {
    sendMessageToWorker,
    sendMessageToWorkerWithResponse
} from '../../helpers/communication'

export type PaymentCelebrationState = {
    client_id: string
    seenCelebration?: boolean
}

type PaymentCelebrationSliceState = {
    paymentCelebrationState?: PaymentCelebrationState
}

const initialState: PaymentCelebrationSliceState = {
    paymentCelebrationState: undefined
}

export const updatePaymentCelebrationDataAction = createAsyncThunk<
    PaymentCelebrationState,
    PaymentCelebrationState
>('paymentCelebration/updatePaymentCelebrationDataAction', async (newData) => {
    sendMessageToWorker({
        [constants.MESSAGES.UPDATE_PAYMENT_CELEBRATION_STORE]: newData
    })
    return newData
})

export const getPaymentCelebrationDataAction = createAsyncThunk<
    PaymentCelebrationState,
    string,
    { rejectValue: string }
>(
    'paymentCelebration/getPaymentCelebrationDataAction',
    async (clientId: string, { rejectWithValue }) => {
        try {
            const paymentCelebration = await sendMessageToWorkerWithResponse({
                [constants.MESSAGES.GET_PAYMENT_CELEBRATION_STORE]: clientId
            })
            return paymentCelebration as PaymentCelebrationState
        } catch {
            // The store lookup failing only means no celebration to show.
            return rejectWithValue('Failed to get payment celebration')
        }
    }
)

export const paymentCelebrationSlice = createSlice({
    name: 'paymentCelebrationState',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                updatePaymentCelebrationDataAction.fulfilled,
                (state, action) => {
                    state.paymentCelebrationState = action.payload
                }
            )
            .addCase(
                getPaymentCelebrationDataAction.fulfilled,
                (state, action) => {
                    state.paymentCelebrationState = action.payload
                }
            )
    }
})

export default paymentCelebrationSlice.reducer
